module.exports = __webpack_public_path__ + "static/img/baa3dee357f7324c5a508496b74da251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_05.png
// module id = JYii
// module chunks = 1